import { createContext, useContext } from 'react'

/** A janela do browser onde o painel está a ser mostrado: a destacada,
 *  ou null quando está na janela principal. */
export const JanelaDoPainelContext = createContext<Window | null>(null)

/** A janela onde o painel vive. Listeners de teclado, `confirm` e afins
 *  têm de ir para aqui: na janela destacada, `window` continua a ser a
 *  principal (é o mesmo contexto JS). */
export function useJanelaDoPainel(): Window {
  return useContext(JanelaDoPainelContext) ?? window
}

/** A janela de um nó do DOM (a do documento onde ele está). Serve nos
 *  handlers de eventos: `janelaDe(e.currentTarget).confirm(...)`. */
export function janelaDe(no: Node | null | undefined): Window {
  return no?.ownerDocument?.defaultView ?? window
}
